import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader } from "../components/ui/card";
import { Skeleton } from "../components/ui/skeleton";
import { TokenList } from "../components/tokens/TokenList";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { strings } from "../lib/strings";
import { useTokens } from "../lib/tokens";
import { useWorkspace } from "../lib/workspaces";
import { AdministratorsOnly } from "../components/ui/states";

const words = strings.tokens;

/** Every API token in the workspace, for Steer's Administrators (BUILD_SPEC §8.5): whose each is, and revoking any. */
function TokensRoute() {
  const view = useWorkspace(workspaceSlug());
  const administrator = view.data?.role === "administrator";
  const tokens = useTokens(true, administrator);
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  if (!administrator) return <AdministratorsOnly what={strings.states.adminPages.tokens} />;
  return (
    <div className="mx-auto max-w-3xl space-y-6 py-12">
      <Card>
        <CardHeader>
          <h1 className="text-xl leading-none font-semibold tracking-tight">{words.adminTitle}</h1>
          <CardDescription>{words.adminBody}</CardDescription>
        </CardHeader>
        <CardContent>
          {tokens.data === undefined ? <Skeleton className="h-24 w-full" /> : <TokenList tokens={tokens.data} owners />}
        </CardContent>
      </Card>
    </div>
  );
}

export const Route = createFileRoute("/admin/settings/tokens")({ component: TokensRoute });
